import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { JVInput } from "../../shared/JVInput";
import { Fetch } from "../../shared/Fetch";
import { IUsersDropdown, IBranchMastDropdown, IVisaDropdown, IBenchConsDropdown, IStateMastDropdown, ICityMastDropdown } from "../../models/IDropdown";
import { JVDropdown } from "../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { JVDropdownInput } from "../../shared/JVDropdownInput";

interface IFilterBench {
    consultant?: number | null | IBenchConsDropdown,
    job_Title?: string | null,
    visa?: number | null,
    state?: number | null | IStateMastDropdown,
    city?: number | null | ICityMastDropdown,
    recruiter?: number | null,
    sales?: number | null,
    branch?: number | null,
    priority?: string | null,
    consultant_Type?: string | null,
    marketing_Status?: string | null
}
const EmptyFilterBench: IFilterBench = {
    consultant: null,
    job_Title: "",
    visa: null,
    state: null,
    city: null,
    recruiter: null,
    sales: null,
    branch: null,
    priority: null,
    consultant_Type: null,
    marketing_Status: null
}

interface Iprops {
    setFilters: (filters: string | null) => void,
}

export const Filter = (props: Iprops) => {
    const [benchConsultant, setBenchConsultant] = useState<Array<IBenchConsDropdown>>();
    const [cities, setCities] = useState<Array<ICityMastDropdown>>();
    const [states, setStates] = useState<Array<IStateMastDropdown>>();
    const [branch, setBranch] = useState<Array<IBranchMastDropdown>>();
    const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
    const [sm, setSM] = useState<Array<IUsersDropdown>>();
    const [visa, setVisa] = useState<Array<IVisaDropdown>>();
    const priority = [{ priority: "High" }, { priority: "Medium" }, { priority: "Low" }];
    const consultant = [{ consultant: "C2C" }, { consultant: "W2" }];
    const status = [{ status: "Hold" }, { status: "Marketing Start" }, { status: "Stop" }];

    const loadSm = async () => {
        const response = await Fetch("Dropdown/UsersByRole", "GET", null, `role_id=${2}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            setSM(data);
        }
    }
    const loadRecruiters = async () => {
        const response = await Fetch("Dropdown/UsersByRole", "GET", null, `role_id=${3}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            setRecruiters(data);
        }
    }
    const loadVisa = async () => {
        const response = await Fetch("Dropdown/visa", "GET", null, null, null);
        if (response) {
            const data: Array<IVisaDropdown> = await response.json();
            setVisa(data);
        }
    }
    const loadBranch = async () => {
        const response = await Fetch("Dropdown/Branches", "GET", null, null, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            setBranch(data);
        }
    }
    const loadCities = async (filter: string | null) => {
        const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<ICityMastDropdown> = await response.json();
            setCities(data);
        }
    }
    const completeMethodCities = (event: { query: string }) => {
        loadCities(event.query);
    }

    const loadStates = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            setStates(data);
        }
    }
    const completeMethodStates = (event: { query: string }) => {
        loadStates(event.query);
    }

    const loadBenchConsultant = async (filter: string | null) => {
        const response = await Fetch("Dropdown/benchConsultant", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IBenchConsDropdown> = await response.json();
            setBenchConsultant(data);
        }
    }
    const completeMethodBenchConsultant = (event: { query: string }) => {
        loadBenchConsultant(event.query);
    }

    useEffect(() => {
        loadSm();
        loadVisa();
        loadBranch();
        loadRecruiters();
    }, []);

    const { control, handleSubmit, reset } = useForm<IFilterBench>({
        defaultValues: EmptyFilterBench,
        shouldFocusError: false
    });

    const searchToDB = async (body: IFilterBench) => {
        body.city = typeof (body.city) === 'number' ? body.city : body.city?.city_ID;
        body.state = typeof (body.state) === 'number' ? body.state : body.state?.state_ID;
        body.consultant = typeof (body.consultant) === 'number' ? body.consultant : body.consultant?.consultant_ID;
        // console.log(body);
        props.setFilters(JSON.stringify(body));
    }

    function onSubmit(data: IFilterBench) {
        searchToDB(data);
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            {/* <JVInput column={6} label="Consultant Name" control={control} name="consultant" /> */}
            <JVDropdownInput column={6} completeMethod={completeMethodBenchConsultant} label="Consultant Name" control={control} name="consultant" options={benchConsultant} optionLabel="consultant_Name" placeholder="Search Consultant Name" />
            <JVInput column={6} label="Job Title" control={control} name="job_Title" />
            <JVDropdown column={6} label="Visa" control={control} name="visa" options={visa} optionLabel="visa_Name" optionValue="visaId" placeholder="Select Visa" />
            <JVDropdown column={6} label="Branch" control={control} name="branch" options={branch} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />
            <JVDropdown column={6} label="Recruiter" control={control} name="recruiter" options={recruiters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" />
            <JVDropdown column={6} label="SM" control={control} name="sales" options={sm} optionLabel="user_Name" optionValue="login_ID" placeholder="Sales Manager" />

            <JVDropdownInput column={6} completeMethod={completeMethodStates} label="State" control={control} name="state" options={states} optionLabel="state_Name" placeholder="Search State" />
            <JVDropdownInput column={6} completeMethod={completeMethodCities} label="City" control={control} name="city" options={cities} optionLabel="city_Name" placeholder="Search City" />
            <JVDropdown column={6} label="Priority" control={control} name="priority" options={priority} optionLabel="priority" optionValue="priority" placeholder="Select Priority" />
            <JVDropdown column={6} label="Consultant Type" control={control} name="consultant_Type" options={consultant} optionLabel="consultant" optionValue="consultant" placeholder="Select Consultant" />
            <JVDropdown column={6} label="Status" control={control} name="marketing_Status" options={status} optionLabel="status" optionValue="status" placeholder="Sales Status" />

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6  h-2rem" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLEAR" onClick={() => { reset(EmptyFilterBench) }} type="button"></Button>
            </div>
        </form>
    );
}